module.exports = __webpack_public_path__ + "img/pic-10.8fd1534d.png";